import { Wrapper } from '@american-autonomy/ag-ui';

import EntitySelectPillButton from 'components/EntitySelectPillButton';
import WithField from 'components/WithField';
import PartSelectPanelField from 'components/fields/PartSelectPanelField';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FieldValues, Props } from './types';

import styles from './styles.module.scss';

const SelectPartField = <T extends FieldValues>(props: Props<T>) => {
    const {
        assetId,
        className = '',
        control,
        isOpen,
        isPlain,
        isRequired,
        label,
        name,
        onPanelClose,
        onPanelOpen,
        placeholder,
        ref,
        testId = TEST_ID
    } = props;

    const { PART } = useTranslation();

    const { containerRef, handleClose, handleToggle, isPanelOpen, onChange, value } = useData<T>({
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref
    });

    const fieldLabel = label ?? PART;

    return (
        <Wrapper className={`${styles.wrapper} ${className}`} ref={containerRef} testId={testId}>
            <WithField isPlain={isPlain} isRequired={isRequired} label={fieldLabel}>
                <EntitySelectPillButton
                    className={styles.pillButton}
                    hasValue={!!value}
                    onClick={handleToggle}
                    onRemove={() => onChange(null)}
                    text={value?.label ?? placeholder ?? PART}
                />
            </WithField>

            {isPanelOpen && (
                <PartSelectPanelField
                    assetId={assetId}
                    onChange={onChange}
                    onClose={handleClose}
                    value={value}
                />
            )}
        </Wrapper>
    );
};

export default SelectPartField;
